import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function ReferralStrip() {
  return (
    <section data-testid="referral-strip" className="py-12 md:py-16 relative overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden border border-[#F57C00]/40 bg-gradient-to-r from-[#F57C00] via-[#E67300] to-[#B85C00] px-8 py-12 md:px-14 md:py-14">
            <div className="absolute -right-10 -top-16 opacity-10 pointer-events-none" aria-hidden="true">
              <Gift size={320} strokeWidth={0.8} className="text-white" />
            </div>
            <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 text-white/90 text-xs uppercase tracking-[0.25em] font-bold mb-4">
                  <Gift size={16} /> Referral programme
                </span>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white mb-3">
                  Know someone who needs a car? Pocket R500.
                </h2>
                <p className="text-base text-white/80 leading-relaxed">
                  Share your personal link from the client portal. When your friend signs their
                  agreement, R500 comes off your ownership balance — or lands in your hand if
                  you're already settled. Unlimited referrals.
                </p>
              </div>
              <div className="shrink-0">
                <Link
                  to="/refer-a-friend"
                  data-testid="referral-strip-cta"
                  className="inline-flex items-center gap-2 bg-white text-[#B85C00] hover:bg-[#0B1F4E] hover:text-white font-bold px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-1 shadow-lg"
                >
                  How it works <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
